import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, {useState} from "react";
import {get, post} from '../../lib/axios'
import {connect} from "react-redux";

function CreateGroup({is_open, selected_map_id, close, set, target, position, group_add_open, open_group_member_select}) {
    const [label, setLabel] = useState('');
    const handleSubmit = () => {
        // [#133 재설계] 빈 캔버스에서 그룹을 만드는 경우(target 없음)는 이 시점에 노드를 바로 만들지 않는다.
        // 이름만 확정해두고 "지식 선택" 단계로 넘어가서, 사용자가 1개 이상 선택해 "선택완료"를 눌러야
        // 그 때 비로소 그룹 노드와 멤버 편입이 함께 생성된다.
        if (!target) {
            close();
            open_group_member_select(label, position);
            setLabel('');
            return;
        }

        let data = {
            label: label,
            x: position.x,
            y: position.y,
            member: target
        };
        post(`/api/v1/seomalmap/${selected_map_id}/node/?type=group`, data, function (result) {
            close();
            get(`/api/v1/seomalmap/${selected_map_id}/`, {}, (json) => {
                set(json.data.elements, Number(selected_map_id), {read_public: json.data.read_public, write_public: json.data.write_public})
            });
            // [#128] 기존 노드를 우클릭해서 그룹을 만든 경우, 클릭한 노드가 첫 멤버로 편입된 뒤
            // 이어서 다른 노드를 추가로 선택할 수 있는 "그룹에 지식 추가" 절차가 곧바로 시작된다.
            group_add_open('N' + result.data.id);
            setLabel('');
        });
    };

    const isValidLabel = (label) => {
        if (label.length > 0) {
            return [true, null]
        } else {
            return [false, '값이 없습니다']
        }
    };
    const labelValidResult = isValidLabel(label);

    return (
        <Dialog open={is_open} onClose={close} style={{zIndex:10000}}>
            <DialogTitle>지식 그룹 생성</DialogTitle>
            <DialogContent style={{minWidth:'310px'}}>
                <DialogContentText>
                    묶음 안의 지식은 하나만 배워도 다음 지식을 배울 수 있어요.
                </DialogContentText>
                <TextField label="그룹 이름" error={!labelValidResult[0]} helperText={labelValidResult[1]} value={label} fullWidth autoFocus
                           onChange={(e) => setLabel(e.target.value)}></TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={close} color="primary">
                    취소
                </Button>
                <Button onClick={handleSubmit} color="primary" disabled={!labelValidResult[0]}>
                    만들기
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default connect(
    (state, ownProps) => {
        return {
            is_open: state.getIn(['ui', 'create_group_is_open']),
            selected_map_id: state.getIn(['map', 'selected_map_id']),
            target: state.getIn(['ui', 'create_group_target']),
            position: state.getIn(['ui', 'cursor_last_tab_position'])
        }
    },
    (dispatch) => {
        return {
            close: () => dispatch({type: 'CLOSE_CREATE_GROUP'}),
            set: (value, map_id, permission) => {
                dispatch({type: 'SET_MAP', value: value, selected_map_id: map_id, permission: permission})
            },
            group_add_open: (group) => dispatch({type: 'GROUP_ADD_OPEN', group}),
            open_group_member_select: (label, position) => dispatch({type: 'OPEN_GROUP_MEMBER_SELECT', label, position})
        }
    }
)(CreateGroup)
